export const getRs485ChlorinatorWarnings = (raw: number): string[] => {
  const warnings: string[] = [];

  if ((raw >> 0) & 1) warnings.push('No Water Detected');
  if ((raw >> 1) & 1) warnings.push('Low Salt');
  if ((raw >> 2) & 1) warnings.push('High Salt');
  if ((raw >> 3) & 1) warnings.push('Overheat');
  if ((raw >> 4) & 1) warnings.push('Overcurrent');
  if ((raw >> 5) & 1) warnings.push('A Low Voltage');
  if ((raw >> 6) & 1) warnings.push('B Low Voltage');
  if ((raw >> 7) & 1) warnings.push('Timer Too High');
  if ((raw >> 8) & 1) warnings.push('Consecutive Firing');
  if ((raw >> 9) & 1) warnings.push('Dead MOSFET');

  return warnings;
};

export const getRs485OzoneWarnings = (raw: number): string[] => {
  const warnings: string[] = [];

  if ((raw >> 0) & 1) warnings.push('Over Current');
  if ((raw >> 1) & 1) warnings.push('No Current');
  if ((raw >> 2) & 1) warnings.push('No Airflow');
  if ((raw >> 3) & 1) warnings.push('Low Airflow Test Temp Error');
  if ((raw >> 4) & 1) warnings.push('Low Airflow Test Current Error');

  return warnings;
};
